export function ConvertToRadians(degree) {
    return degree * Math.PI / 180;
}